import { render } from "./PrintTempSelectPlatform.vue?vue&type=template&id=3d202687&ts=true"
import script from "./PrintTempSelectPlatform.vue?vue&type=script&lang=ts"
export * from "./PrintTempSelectPlatform.vue?vue&type=script&lang=ts"

import "./PrintTempSelectPlatform.vue?vue&type=style&index=0&id=3d202687&lang=scss"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__